'use strict';

var _ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('materialize-css');
require('slick-carousel');
require('sweetalert');
require('./projects');
require('./about');

let lazyImages = [...document.querySelectorAll('.lazy')];

function lazyLoad() {
    lazyImages.forEach(image => {
        if(elementVisible(image)){
            image.src = image.dataset.src;
            image.onload = () => image.classList.add('loaded');
        }
    });
}

window.addEventListener('scroll', _.throttle(lazyLoad, 16));
window.addEventListener('resize', _.throttle(lazyLoad, 16));
if(window.location.pathname == '/'){
    document.getElementById('sliderRowBlog').addEventListener('scroll', _.throttle(lazyLoad, 16));
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            lazyLoad();
        },0);
    }
    window.load = cargar();
    $('.modal').modal({
        dismissible: false,
    });
    $('#mobile_menu').sidenav({
        edge: 'right',
    });
    $('#list_search').sidenav({
        edge: 'left',
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('.header .menu').click(function () {
    $('#mobile_menu').sidenav('open');
});

$('.listEvents,.list').click(function () {
    $('#list_search').sidenav('open');
});

$('.sidenav').click(function (e) {
    if($(e.target).parents('.element').length == 0)
        $('.sidenav').sidenav('close');
});

$('.clickContact').click(function () {
    $('#modalContact').modal('open');
});

$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});

$('#modalContact').click(function (e) {
    if($(e.target).parents('.rowOne').length == 0)
        $('#modalContact').modal('close');
});

$('.sectionBanner .rowTwo .row,.sectionBlogHome .sliderRow .element').click(function (e) {
    $('#modalBlog').modal('open');
});

function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}


$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').addClass('header-shadow');
            $('.header').css('background','#ffffff');
            $('.header .face').attr('src',https+'img/header/face_down.svg');
            $('.header .twitter').attr('src',https+'img/header/twitter_down.svg');
            $('.header .menu').attr('src',https+'img/header/menu_down.svg');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').removeClass('header-shadow');
                $('.header').css('background','transparent');
                $('.header .face').attr('src',https+'img/header/face.svg');
                $('.header .twitter').attr('src',https+'img/header/twitter.svg');
                $('.header .menu').attr('src',https+'img/header/menu.svg');
            }
        }
    }
});

setInterval(function () {
    if ($(window).width() > 600) {
        $('.modalBlog .banner').css('height',$('.modalBlog .rowOne').css('height'));
    }
},100);
